// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetSensorMeasurementsRequestModel from '../../model/get-sensor-measurements-request-model';
import GetCustomersRequestModel from '../../model/get-customers-request-model';
import GetProjectsRequestModel from '../../model/get-projects-request-model';
import GetSensorIdsRequestModel from '../../model/get-sensor-ids-request-model';
import GetSensorTypesRequestModel from '../../model/get-sensor-types-request-model';
import GetSensorConfigsRequestModel from '../../model/get-sensor-configs-request-model';
import PostExcelRequestModel from '../../model/post-excel-request-model';
import SensorListPagingResultModel from '../../model/sensor-list-paging-result-model';
import StringListResultModel from '../../model/string-list-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async getSensorMeasurements(request: GetSensorMeasurementsRequestModel, config?: RequestConfig) {
    const requestDTO = GetSensorMeasurementsRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-sensor-measurements'] ?? 'SensorMeasurements';
    const response = await service.get<any>(endpointPath, {
      query: {
        from: requestDTO.from,
        until: requestDTO.until,
        selectedCustomer: requestDTO.selectedCustomer,
        selectedProject: requestDTO.selectedProject,
        selectedSensorId: requestDTO.selectedSensorId,
        selectedSensorTyp: requestDTO.selectedSensorTyp,
        selectedSensorConfig: requestDTO.selectedSensorConfig,
        id: requestDTO.id,
        key: requestDTO.key,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(SensorListPagingResultModel.toModel(dto));
  },
  /**  */
  async getCustomers(request: GetCustomersRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-customers'] ?? 'SensorMeasurements/Customers';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(StringListResultModel.toModel(dto));
  },
  /**  */
  async getProjects(request: GetProjectsRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-projects'] ?? 'SensorMeasurements/Projects';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(StringListResultModel.toModel(dto));
  },
  /**  */
  async getSensorIds(request: GetSensorIdsRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-sensor-ids'] ?? 'SensorMeasurements/SensorIds';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(StringListResultModel.toModel(dto));
  },
  /**  */
  async getSensorTypes(request: GetSensorTypesRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-sensor-types'] ?? 'SensorMeasurements/SensorTypes';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(StringListResultModel.toModel(dto));
  },
  /**  */
  async getSensorConfigs(request: GetSensorConfigsRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-sensor-configs'] ?? 'SensorMeasurements/SensorConfigs';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(StringListResultModel.toModel(dto));
  },
  /**  */
  async postExcel(request: PostExcelRequestModel, config?: RequestConfig) {
    const requestDTO = PostExcelRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-post-excel'] ?? 'SensorMeasurements/Excel';
    const response = await service.post<any>(endpointPath, {
      responseType: 'blob',
      query: {
        from: requestDTO.from,
        until: requestDTO.until,
        selectedCustomer: requestDTO.selectedCustomer,
        selectedProject: requestDTO.selectedProject,
        selectedSensorId: requestDTO.selectedSensorId,
        selectedSensorTyp: requestDTO.selectedSensorTyp,
        selectedSensorConfig: requestDTO.selectedSensorConfig,
        id: requestDTO.id,
        key: requestDTO.key,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(new Blob([result], { type: 'application/octet-stream' }));
  },
});
